import React from 'react';

export const DisabledTagsMessage = () => (
  <div className="alert alert-warning">
    <strong>Warning:</strong> Tags are disabled for this Salesforce account.
    <br />
    <a
      href="https://help.salesforce.com/s/articleView?id=sf.customize_tag_settings.htm&type=5"
      target="_blank"
      rel="noopener noreferrer"
    >
      How to enable tags?
    </a>
  </div>
);
